import Page from './RegistrationPage';

export default Page;
